import { Controller } from "stimulus"

// A file input that also accepts a pasted image, with a small chip showing
// what's attached and a button to remove it.
export default class extends Controller {
  static targets = ["input", "button", "hint", "preview", "name"]

  paste(event) {
    const data = event.clipboardData
    if (!data || !this.hasInputTarget) return
    // Leave ordinary text pastes alone, even when an image rides along.
    if (data.getData("text/plain")) return

    const file = Array.from(data.files || []).find(item => item.type.startsWith("image/"))
    if (!file) return

    event.preventDefault()
    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.inputTarget.files = transfer.files
    this.show()
  }

  show() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) {
      this.clear()
      return
    }
    this.nameTarget.textContent = file.name || "screenshot.png"
    this.previewTarget.hidden = false
    this.buttonTarget.hidden = true
    if (this.hasHintTarget) this.hintTarget.hidden = true
  }

  clear() {
    this.inputTarget.value = ""
    this.previewTarget.hidden = true
    this.buttonTarget.hidden = false
    if (this.hasHintTarget) this.hintTarget.hidden = false
  }
}
